import { Store } from '@ngrx/store';
import { AfterViewInit, Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ValidationResponseHandlerModule } from 'app/Shared/ValidationResponse/validation-response-handler';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppState } from 'app/store/model';
import { ResultAlert } from 'app/Shared/models';
import { Subscription } from 'rxjs';
import { UserActions } from '../Services/actions';
import { SharedService } from 'app/Shared/Services/shared.service';
import { Router } from '@angular/router';
import { Plan } from 'app/cameras/models';
import { UserInventory } from '../models';

export interface KitsElements {
    plan: string;
    amount: string;
    id: number;
}

@Component({
    selector: 'app-user-stock-manager',
    templateUrl: './user-stock-manager.component.html',
    styleUrl: './user-stock-manager.component.scss',
    standalone: false
})
export class UserStockManagerComponent implements OnInit, OnDestroy, AfterViewInit {
    readonly deleteKitSub$ = this.store.select((state: AppState) => state.Users.deleteMasterKit);
    readonly createTicketKit$ = this.store.select((state: AppState) => state.Users.createTicketKit);
    readonly transferItems$ = this.store.select((state: AppState) => state.Users.transferItemsFeedback);

    @Output() modalClose = new EventEmitter<string>();

    editForm = new UntypedFormGroup({
        planAmount: new UntypedFormControl('', [Validators.required]),
        detectionsAmount: new UntypedFormControl('', [Validators.required])
    });

    elementsKit: KitsElements[] = [
        {plan: '', amount: '', id: 1}
    ];

    newElementsKit: KitsElements = {
        plan: '', amount: '', id: 2
    };

    deleteKitSub: Subscription;
    swalDecisionSub: Subscription;
    transferItemsSub: Subscription;
    createTicketKitSub: Subscription;

    partnerName: string;
    kitInfo: any;
    inventoryInfo: any;
    camResolution: string;
    camDays: number;
    qtdCam: number;
    qtdAnalytic: number;
    analyticTotal: number;
    calcAnalytic: number;
    id_plan: number;
    sub: string;
    client_sub: string;
    loading: boolean;
    selectedPlan: number;
    environment: string;
    optionsPlan: any;
    errorPass: boolean;
    planValues: any = [];
    plans: Plan[];
    selectedPlanError: boolean;
    analyticMin = 0;
    analyticTotalDisplay: number | null = null;
    firstLoad = true;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private readonly store: Store<AppState>,
        private validationResponse: ValidationResponseHandlerModule, private service: SharedService, private router: Router) { }


    ngOnInit(): void {
        this.sub = localStorage.getItem('sub');
        this.client_sub = localStorage.getItem('clientView');

        this.loading = false;
        this.selectedPlanError = false;
        // payload do modal
        this.environment = this.data.data.env;
        this.plans = this.data.data.plans;
        this.inventoryInfo = this.data.data.inventory_info;
        this.partnerName = this.inventoryInfo.inventory.name;
        this.qtdAnalytic = this.inventoryInfo.inventory.ai?.available;

        this.transferItemsResult();
        this.swalDecisionSub = this.service.swalDecision.subscribe(returnSwallObject => {
            if (returnSwallObject) {
                this.validateReturnMethodCalled(returnSwallObject as ResultAlert);
            }
        });
        if (this.environment !== 'kit-list') {
            this.optionsPlan = this.processList(this.plans);

            if (this.environment === 'detections-stock') {
            // ===== calcular usados/disponíveis e aplicar regras do input =====
                const ai = this.inventoryInfo?.inventory?.ai ?? {};
                const used = Number(ai.used) || 0;
                const available = Number(ai.available) || 0;
                const total = used + available;

                // mínimo = used
                this.analyticMin = used;

                // mantém analyticTotal como number (sem string)
                this.analyticTotal = total > 0 ? total : 0;

                // exibição do input (fica vazio quando total == 0)
                this.analyticTotalDisplay = total > 0 ? total : null;

                // se houver um FormControl correspondente no modal, sincroniza com a exibição
                if (this.editForm?.get?.('detectionsAmount')) {
                    this.editForm.get('detectionsAmount')!.setValue(this.analyticTotalDisplay, { emitEvent: false });
                }
                // ================================================================

                this.elementsKit = Object.values(this.inventoryInfo.inventory.ci as UserInventory)
                    .filter(item => item.id_plan !== undefined)
                    .map(item => ({
                        plan: item.id_plan,
                        amount: item.available + item.used,
                        id: item.id
                    }));

                if (this.elementsKit.length === 0) {
                    this.newKits();
                }
            }
        } else {
            this.kitInfo = this.data.data.kit_info;
            this.camResolution = this.kitInfo.plan.resolution.alias;
            this.camDays = this.kitInfo.plan.days_storage;
            this.id_plan = this.kitInfo.id_plan;

            this.qtdCam = this.inventoryInfo.inventory.ci[this.id_plan].available;
            this.calcAnalytic = Math.floor((this.qtdCam / this.kitInfo.cameras_amount) * this.kitInfo.analytics_amount);
            this.editForm.get('planAmount').setValue(this.qtdCam);

            // mantém number; se <= 0, deixa o campo vazio (null)
            this.editForm.get('detectionsAmount').setValue(this.calcAnalytic);
        }
    }

    ngAfterViewInit() {
        this.firstLoad = false;
    }


    checkLimit() {
        if (this.editForm.get('planAmount').value == '') {
            this.editForm.get('planAmount').setErrors({'required': true});
        } else {
            this.editForm.get('planAmount').setErrors(null);
        }


        if (this.editForm.get('detectionsAmount').value == '' && this.editForm.get('planAmount').value != '') {
            this.editForm.get('detectionsAmount').setErrors({'required': true});
        } else {
            this.editForm.get('detectionsAmount').setErrors(null);
        }
    }

    ngOnDestroy() {
        if (this.deleteKitSub) {
            this.deleteKitSub.unsubscribe();
        }
        if (this.swalDecisionSub) {
            this.swalDecisionSub.unsubscribe();
        }
        if (this.transferItemsSub) {
            this.transferItemsSub.unsubscribe();
        }

        this.closeModal();
        this.store.dispatch(UserActions.delete_master_kit_cleanup());
        this.store.dispatch(UserActions.edit_kit_modal_cleanup());
        this.store.dispatch(UserActions.cleanup());
        this.elementsKit = [{plan: '', amount: '', id: 1}];
    }


    closeModal() {
        this.modalClose.emit();
    }

    reloadComponent() {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        localStorage.setItem('activeTab', 'stock');
        this.router.navigate([this.router.url]);
    }

    deleteKit() {
        this.validationResponse.validationResponseHandler(200, 'user-kits', 'master-confirm-delete-kit', 'user.delete_master_kit');
    }

    validateReturnMethodCalled(returnSwal: ResultAlert) {
        if (returnSwal.methodCalled === 'deleteMasterKit') {
            if (returnSwal.isConfirmed) {
                this.loading = true;
                this.store.dispatch(UserActions.delete_master_kit({
                    sub: this.sub,
                    child_sub: this.client_sub,
                    id_plan: this.id_plan,
                    cameras_amount: this.editForm.get('planAmount').value,
                    analytics_amount: this.editForm.get('detectionsAmount').value
                }));
                this.deleteKitResult();
            }
            else if (returnSwal.isDismissed) {
            }
        }
    }

    deleteKitResult() {
        this.deleteKitSub = this.deleteKitSub$.subscribe(result => {
            if (result) {
                this.loading = false;
                if (result.status === 2) {
                    this.validationResponse.validationResponseHandler(200, 'user-kits', 'delete-kit', result.message);
                    this.closeModal();
                    this.reloadComponent();
                } else {
                    this.validationResponse.validationResponseHandler(400, 'user-kits', 'delete-kit-fail', result.message);
                }
                this.store.dispatch(UserActions.delete_master_kit_cleanup());
            }
        });
    }

    filteredOptions() {
        const filtered = this.plans.filter(item => !this.elementsKit.map(e => Number(e.plan)).includes(item.id));
        return this.optionsPlan = this.processList(filtered);
    }


    newKits() {
        const newElements = {plan: this.newElementsKit.plan, amount: this.newElementsKit.amount, id: this.newElementsKit.id};
        this.elementsKit = [...this.elementsKit, newElements];
        this.newElementsKit.id = this.elementsKit.length + 1;
        this.filteredOptions();
    }

    removeKit(id) {
        this.elementsKit.splice(id, 1);
        this.elementsKit = [...this.elementsKit];
        this.filteredOptions();
    }

    processList(list) {
        return list.map(element => {
            return {
                id: element.id,
                title: `Câmera ${element.resolution.alias}`,
                description: `${element.days_storage} ${this.processPlural('dia', element.days_storage)}`
            };
        });
    }

    processPlural(text, number) {
        return text + (number == 1 ? '' : 's');
    }

    getPlanAmount(event, i) {
        this.elementsKit[i].amount = event;
    }

    setAnalyticTotal(val: number | null) {
        this.analyticTotalDisplay = val;
        this.analyticTotal = typeof val === 'number' ? val : 0;
    }

    changePlan(event, i) {
        if (!this.firstLoad) {
            this.elementsKit[i].plan = event[0];
            this.filteredOptions();
        }
    }

    requestKit() {
        if (this.loading) {
            return false;
        }
        this.loading = true;

        const plans = [];
        this.elementsKit.map((value) => {
            plans.push({
                id_plan: value.plan,
                cameras_amount: value.amount
            });
        });

        this.errorPass = this.elementsKit.some(element => element.plan == '' || (element.plan != '' && element.amount == ''));

        if (!this.errorPass) {
            this.store.dispatch(UserActions.create_ticket_kit({
                sub: localStorage.getItem('sub'),
                plans: plans,
                analytics_amount: this.analyticTotal
            }));
        } else {
            this.loading = false;
            this.validationResponse.validationResponseHandler(400, 'user', 'create-ticket-fail', 'Preencha as informações completamente.');
        }
        this.createTicketResult();
    }

    createTicketResult() {
        this.createTicketKitSub = this.createTicketKit$.subscribe(result => {
            if (result) {
                this.loading = false;
                if (result.status === 2) {
                    this.validationResponse.validationResponseHandler(200, 'user', 'create-ticket', 'stock.transfer_items');
                    this.closeModal();
                } else {
                    this.validationResponse.validationResponseHandler(400, 'user', 'create-ticket-fail', result.message);
                }
            }
        });
    }


    updateKit() {
        if (this.loading) {
            return false;
        }

        this.loading = true;

        const cams = [];
        this.elementsKit.map((value) => {
            cams.push({
                plan_id: value.plan,
                amount: value.amount
            });
        });

        this.errorPass = cams.some(element => element.plan_id.toString() == '' || (element.plan_id.toString() != '' && element.amount.toString() === ''));

        if (!this.errorPass) {
            this.store.dispatch(UserActions.transfer_items({
                user_sub: localStorage.getItem('sub'),
                buyers_sub: localStorage.getItem('clientView'),
                kits: null,
                cameras: cams,
                analytics_amount: this.analyticTotal
            }));
        } else {
            this.loading = false;
        }
    }

    transferItemsResult() {
        this.transferItemsSub = this.transferItems$.subscribe(result => {
            if (result) {
                this.loading = false;
                if (result.status === 2) {
                    this.validationResponse.validationResponseHandler(200, 'user', 'transfer-items', result.message);
                    this.closeModal();
                    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                    this.router.onSameUrlNavigation = 'reload';
                    this.router.navigate([this.router.url]);
                } else {
                    this.validationResponse.validationResponseHandler(400, 'user', 'transfer-items-fail', result.message);
                }
                this.store.dispatch(UserActions.edit_kit_modal_cleanup());
            }
        });
    }

}
